import { render } from "./HomeSmartphone.vue?vue&type=template&id=687cd84e&scoped=true"
import script from "./HomeSmartphone.vue?vue&type=script&lang=js"
export * from "./HomeSmartphone.vue?vue&type=script&lang=js"

import "./HomeSmartphone.vue?vue&type=style&index=0&id=687cd84e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687cd84e"]])

export default __exports__